import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export function DirectionPill({
  direction,
  icon: Icon,
  label,
}: {
  direction: 'inbound' | 'outbound'
  icon: LucideIcon
  label: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md px-2.5 py-1',
        direction === 'inbound'
          ? 'bg-green-50 text-green-600'
          : 'bg-sky-50 text-sky-700'
      )}>
      <Icon className="h-3.5 w-3.5" aria-hidden />
      <span className="text-sm capitalize">{label}</span>
    </span>
  )
}
